export default __webpack_public_path__ + "locales/az/PreparationPortal.json?hash=6d8dd88b1c31536392662f8a527e8a60";